import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c972eb4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "total" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "客户总数", -1))
const _hoisted_4 = { class: "bars" }
const _hoisted_5 = { class: "label" }
const _hoisted_6 = { class: "value" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "total" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "客户跟进及时率", -1))
const _hoisted_10 = { class: "bars" }
const _hoisted_11 = { class: "label" }
const _hoisted_12 = { class: "value" }
const _hoisted_13 = { class: "rightContainer" }
const _hoisted_14 = { class: "rightTotal" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "客户上门拜访完成率", -1))
const _hoisted_16 = { class: "rightContainer" }
const _hoisted_17 = { class: "rightTotal" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "total-label" }, "异动反馈率", -1))

import { onMounted, onUnmounted, PropType, ref, watch } from 'vue'
import formatThousandSeparator from '@/utils/format'
import { getCustomerKeyDataBoard } from '@/api/gucangSales/regionDataBoard'

const __default__ = {
  name: 'CustomerKeyData'
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  formState: {
    type: Object as PropType<Object>
  }
},
  setup(__props) {

const props = __props
const keyData = ref<any>({})
const totalNumberSize = ref(32)
onMounted(() => {
  totalNumberSize.value = (32 * window.innerWidth / 1920) < 20 ? 20 : (Math.ceil(32 * window.innerWidth / 1920))
  window.addEventListener('resize', handleResize)
  getCustomerDashData()
})
onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
})
const handleResize = () => {
  totalNumberSize.value = (32 * window.innerWidth / 1920) < 20 ? 20 : (Math.ceil(32 * window.innerWidth / 1920))
}
watch(() => props.formState, (val) => {
  getCustomerDashData()
})
const getCustomerDashData = () => {
  getCustomerKeyDataBoard(props.formState)
    .then((res:any) => {
      keyData.value.customerTotal = res.data.customerTotal ?? 0
      keyData.value.customerFollowingUpRate = res.data.customerFollowingUpRate ?? '0%'
      keyData.value.visitCompletedRate = res.data.visitCompletedRate ?? '0%'
      keyData.value.alarmFeedbackRate = res.data.alarmFeedbackRate ?? '0%'
      keyData.value.totalData = [
        {
          desc: '潜在',
          value: res.data.potentialTotal ?? 0,
          color: '#FF9A3E',
          width: '0%'
        },
        {
          desc: '签约',
          value: res.data.contractTotal ?? 0,
          color: '#1CA550',
          width: '0%'
        },
        {
          desc: '成交',
          value: res.data.transactionTotal ?? 0,
          color: '#1D4CD2',
          width: '0%'
        }
      ]
      keyData.value.followRate = [
        {
          desc: '潜在',
          value: res.data.potentialFollowingUpRate ?? '0%',
          color: '#FF9A3E'
        },
        {
          desc: '签约',
          value: res.data.contractFollowingUpRate ?? '0%',
          color: '#1CA550'
        },
        {
          desc: '成交',
          value: res.data.transactionFollowingUpRate ?? '0%',
          color: '#1D4CD2'
        }
      ]
      animateBars()
    })
}
const animateBars = () => {
  const number = keyData.value.totalData.map((item: any) => {
    return item.value
  })
  const max = Math.max(...number)
  keyData.value.totalData.forEach((bar: any, index: number) => {
    setTimeout(() => {
      const percent = bar.value / max
      bar.width = `${percent * 100}%`
    }, 300)// Delay each bar's animation by 300ms
  })
  keyData.value.followRate.forEach((bar: any, index: number) => {
    setTimeout(() => {
      bar.width = bar.value
    }, 300)// Delay each bar's animation by 300ms
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_row, { gutter: 8 }, {
    default: _withCtx(() => [
      _createVNode(_component_a_col, { span: 8 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("span", {
                class: "total-number",
                style: _normalizeStyle({fontSize: `${totalNumberSize.value}px`})
              }, _toDisplayString(_unref(formatThousandSeparator)((keyData.value.customerTotal ?? 0).toString())), 5)
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyData.value.totalData, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "bar"
                }, [
                  _createElementVNode("div", {
                    class: "leftTag",
                    style: _normalizeStyle({ backgroundColor: item.color, width: '10px' })
                  }, null, 4),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(item.desc), 1),
                  _createElementVNode("div", {
                    class: "progress",
                    style: _normalizeStyle({ backgroundColor: item.color, width: item.width })
                  }, null, 4),
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(formatThousandSeparator)(item.value.toString()??'')), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: 8 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("span", {
                class: "total-number",
                style: _normalizeStyle({fontSize: `${totalNumberSize.value}px`})
              }, _toDisplayString(keyData.value.customerFollowingUpRate??'0%'), 5)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(keyData.value.followRate, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "bar"
                }, [
                  _createElementVNode("div", {
                    class: "leftTag",
                    style: _normalizeStyle({ backgroundColor: item.color, width: '10px' })
                  }, null, 4),
                  _createElementVNode("span", _hoisted_11, _toDisplayString(item.desc), 1),
                  _createElementVNode("div", {
                    class: "progress",
                    style: _normalizeStyle({ backgroundColor: item.color, width: item.width  })
                  }, null, 4),
                  _createElementVNode("p", _hoisted_12, _toDisplayString(item.value), 1)
                ]))
              }), 128))
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: 4 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("span", {
                class: "total-number center-rate",
                style: _normalizeStyle({fontSize: `${totalNumberSize.value}px`})
              }, _toDisplayString(keyData.value.visitCompletedRate), 5)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_a_col, { span: 4 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("span", {
                class: "total-number center-rate",
                style: _normalizeStyle({fontSize: `${totalNumberSize.value}px`})
              }, _toDisplayString(keyData.value.alarmFeedbackRate), 5)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})